// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__3TLXR","overflowing":"ReadFullNote_overflowing__2cD-4"};